import * as THREE from 'three';
import UtilSP from 'SATPROF_UTILS/UtilSP';

import { Line2 } from "three/examples/jsm/lines/Line2";
import { LineMaterial } from "three/examples/jsm/lines/LineMaterial";
import { LineGeometry } from "three/examples/jsm/lines/LineGeometry";

export default class PolyLine_grp  extends THREE.Group{
   
    /* 
    Draws a polyline connecting defined points.

    properties:
    points      Array of objects that have x, y, and z properties
    quickSet(x1, y1, z1, x2, y2, z2, linecolor, linewidth)   // Shorthand setup for a line between two points.
    lineColor
    lineWidth
    */

    private _line_m:Line2;
    private _line_g:LineGeometry;
    private _line_mat:LineMaterial;
    private _points:Array<any>;
    private _nPoints:number;

    private pointPositions: Array<number>;
    private _lineWidth:number = 2;
    private _lineColor:string = "yellow";

    constructor(){
        super();
        //console.log("In PolyLine_grp constructor...")
        this.createObject();
    }
    
    //let axesHelper = new THREE.AxesHelper( 5 );  
    private createObject(){
 
        this._line_mat = new LineMaterial();
        this._line_g = new LineGeometry();
        this._line_m = new Line2();
        this.add(this._line_m); 
        //this.points = [{x:0,y:0,z:0}, {x:100,y:100,z:100}] 
        //this.rebuild();
        this._points = [];
        this.rebuild();
    }

    private rebuild(){   
        if (this._points.length < 2){
        //     this._line_g.setPositions([0,0,0, 10,0,0]); // Null 
             return null;
        } 
        this.pointPositions = this._points.flatMap((point: any) => [point.x, point.y, point.z]);
        this._line_g.setPositions(this.pointPositions);
        this._line_mat = new LineMaterial( {color:this._lineColor, linewidth:this._lineWidth } )
        this._line_m.geometry = this._line_g;
        this._line_m.material = this._line_mat
    }
    // public clearAll(){
    //     this._points = [];
    //     this.rebuild();
    // }
    public quickSet(x1:number, y1:number, z1:number, x2:number, y2:number, z2:number, linecolor:string, linewidth:number){
        // Shorthand setup for a line between two points.
        this._points = [{x:x1, y:y1, z:z1}, {x:x2, y:y2, z:z2}];
        this._lineColor = linecolor;
        this._lineWidth = linewidth;
        this.rebuild();
    }
    public set lineColor(val:string){
        this._lineColor = val;
        this.rebuild();
    }
    public get lineColor():string{
        return this._lineColor;
    }	
    public set lineWidth(val:number){
        this._lineWidth = val;
        this.rebuild();
    }
    public get lineWidth():number{
        return this._lineWidth;
    }  

    public set points(pts:Array<any>){
        // Expects array of objects that have x, y, and z properties
        // this._nPoints = val.length;
        // this._points = new Array<any>;
        // for (let i=0; i<this._nPoints; i++){
        //    this._points[i] = {};
        //    this._points[i].x = val[i].x;
        //    this._points[i].y = val[i].y;
        //    this._points[i].z = val[i].z;
        // }
        if (pts.length <2){
            return;
        }
        this._points = pts;
        this.rebuild();
    }
    public get points(){
        return this._points;
    }



}


